const config = {
  rowSelection: false,
  listTitle: '谈单内容配置',
  searchMode: "group",
  tableType: "antd",
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 220,
      ellipsis: true
    },
    {
      title: '菜单名称',
      dataIndex: 'name',
      width: 150,
      ellipsis: true
    },
    {
      title: '菜单编码',
      dataIndex: 'code',
      width: 120,
      ellipsis: true
    },
    {
      title: '排序',
      dataIndex: 'sortNumber',
      width: 100,
      ellipsis: true
    },
    {
      title: '广告数',
      dataIndex: 'dtlNumber',
      width: 100,
      ellipsis: true
    },
    {
      title: '是否启用',
      dataIndex: 'status',
      render: "statusFn",
      width: 120
    },
    {
      title: '更新人',
      dataIndex: 'modifiedByName',
      width: 110,
      ellipsis: true
    },
    {
      title: '更新时间',
      dataIndex: 'lastUpdatedTime',
      itemType: "dateTime",
      width: 150,
      ellipsis: true
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 230,
      render: 'operationFn',
      fixed: 'right',
    },
  ],
  // search: false,
  footer: [
    {
      label: "新增",
      type: "primary",
      events: ["onClick:onAdd"]
    }
  ]
}

export default config
